import { cx } from '../cx'
import styles from './Avatar.module.css'

export function Avatar({
  name,
  kind,
  size = 'md',
  alt = false,
  className,
}: {
  name: string
  kind: 'human' | 'agent' | 'workspace'
  size?: 'sm' | 'md' | 'lg'
  alt?: boolean
  className?: string
}) {
  const initial = ([...name.trim()][0] ?? '?').toUpperCase()
  return (
    <span
      aria-hidden="true"
      className={cx(styles.avatar, className)}
      data-kind={kind}
      data-size={size}
      data-alt={alt && kind === 'human' ? '' : undefined}
    >
      {initial}
    </span>
  )
}
